import type { PropsWithChildren } from 'react'

import { cn } from '@mntn-dev/ui-utilities'
import { type TestIds, getTestProps } from '../../../utils/testing.ts'
import { usePageHeaderContext } from './use-page-header.ts'
import type { PageHeaderSize } from './use-page-header.ts'

const fontSizeMap: Record<PageHeaderSize, string> = {
  sm: 'text-sm',
  md: 'text-lg',
  lg: 'text-lg',
}

export const PageHeaderOverline = ({
  children,
  dataTestId: dataTestIdProp,
  dataTrackingId: dataTrackingIdProp,
}: PropsWithChildren<TestIds>) => {
  const {
    dataTestId: dataTestIdContext,
    dataTrackingId: dataTrackingIdContext,
    size,
  } = usePageHeaderContext()
  const dataTestId = dataTestIdProp || `${dataTestIdContext}-overline`
  const dataTrackingId =
    dataTrackingIdProp || `${dataTrackingIdContext}-overline`

  return (
    <div
      className={cn(
        'flex flex-row items-center justify-start gap-4 h-10',
        fontSizeMap[size]
      )}
      {...getTestProps({ dataTestId, dataTrackingId })}
    >
      {children}
    </div>
  )
}
